module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'h6arpbob',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
